import { fetchWithAuth } from "../FetchHelper";

const apiUrl = process.env.REACT_APP_API_URL;
export const GetBbddPracticaIdImagen = async (id: string) => {
    try {
        const response = await fetchWithAuth(`${apiUrl}:8061/bbdd/practica/${id}/imagen`);
        if (response && response.ok) {
            return await response.json();
        }
        return null;
    } catch (error) {
        console.log('Error al obtener imagen de practica BBDD:', error);
        return null;
    }
};

